import React from 'react';
import {
    SparkleIcon,
    HeartIcon,
} from '@phosphor-icons/react';

export interface DashboardAiDesignsTabChromeProps {
    aiPanelTab: 'ai' | 'tree' | 'saved' | 'wishlist';
    setAiPanelTab: (next: 'ai' | 'tree' | 'saved' | 'wishlist') => void;
    /** Extra class on the tab stack root (e.g. inline dashboard chrome) */
    className?: string;
}

/** All designs-area tabs in one row (dashboard drawer + inline). Labels hide on narrow viewports; icons stay. */
export const DashboardAiDesignsTabChrome: React.FC<DashboardAiDesignsTabChromeProps> = ({
    aiPanelTab,
    setAiPanelTab,
    className,
}) => {
    const onAi = aiPanelTab === 'ai';

    return (
        <div className={`obd-ai-rail__tab-stack obd-ai-rail__tab-stack--single-row${className ? ` ${className}` : ''}`}>
            <div
                className="obd-ai-rail__tabs obd-ai-rail__tabs--single-row"
                role="tablist"
                aria-label="Designs panel"
            >
                <button
                    type="button"
                    role="tab"
                    aria-selected={onAi}
                    title="AI designs"
                    className={`obd-ai-rail__tab obd-ai-rail__tab--single-row ${onAi ? 'obd-ai-rail__tab--active' : ''}`}
                    onClick={() => setAiPanelTab('ai')}
                >
                    <SparkleIcon size={13} weight="fill" aria-hidden />
                    <span className="obd-ai-rail__tab-label">AI designs</span>
                </button>
                <button
                    type="button"
                    role="tab"
                    aria-selected={aiPanelTab === 'wishlist'}
                    title="Wishlist"
                    className={`obd-ai-rail__tab obd-ai-rail__tab--single-row ${aiPanelTab === 'wishlist' ? 'obd-ai-rail__tab--active' : ''}`}
                    onClick={() => setAiPanelTab('wishlist')}
                >
                    <HeartIcon size={13} weight="fill" aria-hidden />
                    <span className="obd-ai-rail__tab-label">Wishlist</span>
                </button>
            </div>
        </div>
    );
};
